<template>
	<div class="content pa-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<!-- <div class="fixed-box" :class="{'navScrollTop':scrollNav==true}" v-show="!navShow">
			<div class="container">
				<div class="fixed-nav" @click="showNav()">{{ productList[0].title }} <i class="icon-arrow el-icon-arrow-down fr" :class="{'remotesY':clickShow==true}"></i></div>
			</div>
		</div> -->
		<div class="navShade" v-show="clickShow"></div>
		<div class="pro-content">
			<div class="container">
				<el-row class="pro-content-row">
					<el-col :xs="24" :md="6" class="nav-menu">
						<!-- <h3>分类</h3> -->
						<!-- :class="{'proScrollTop':scrollNav==true, 'isShowNav':clickShow==true, 'showMenu':clickShow==true}" -->
						<ul class="nav-menu-ul" :class="{'proScrollTop':scrollNav==true, 'isShowNav':clickShow==true, 'showMenu':clickShow==true}">
							<h3 style="font-size: 24px;margin: 15px 12px 10px;" @click="showMenus()">{{ langs.category }} <span class="el-icon-arrow-down fr arrowdown" :class="showmenus?'':'arrowup'"></span></h3>
							<div :class="showmenus?'showmenus':''">
                <!--:class="currMenu==index?'opened':''"-->
								<li class="menu-list" v-for="(item, index) in lists" :key="index">
									<div class="menu-title menu-list-s" @click="selectCurrNav(index, 99)" :class="currMenu==index?'openeds':''">
										<span class="ws iottips">{{ item.title }}</span>
										<span class="iot-number">{{ item.size }}</span>
									</div>
<!--                  <div class="small-menu">-->
<!--                    <div class="small-menu-li menu-list-s" @click="selectCurrNav(index, dindex)" v-for="(dpro, dindex) in item.children">{{ dpro.title }}</div>-->
<!--                  </div>-->
								</li>
							</div>
						</ul>
					</el-col>
					<el-col :xs="24" :md="18">
            <el-row>
              <div class="product-box" v-for="(pro, proindex) in productList" v-show="pro.size > 0" :key="proindex">
                <!--<h4 :id="'title'+proindex">{{ pro.title }}</h4>-->
                <el-col :xs="12" :md="8" v-for="(child, childindex) in pro.children" :key="childindex">
                  <div class="product-list">
                    <div class="product-list-image">
                      <el-image
                        :src="require('../../static/images/products/'+ (currMenu+1) +'/'+ (proindex+1) +'/'+ (childindex+1) +'/1.png')" lazy>
                      </el-image>
                    </div>
                    <div class="pro-model ws">{{ child.title }}</div>
                    <div class="dtl-link">
                      <a :href="child.buylink" class="buy_link" target="_blank" tips="购买" v-show="child.desc != 1">{{ langs.index35 }}</a>
                      <router-link class="dtl-btn" target="_blank" tips="详情" :to="{ name:'prodetail', query:{id:currMenu, seq:proindex, index:childindex, name:child.title, queryLangs:currlangs }}">
                        <el-button type="text">{{ langs.iot5 }}</el-button>
                      </router-link>
                    </div>
                  </div>
                </el-col>
              </div>
            </el-row>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				showLoading: true,
				productList: [],
				currlangs:0, //0中文 1英文 2西班牙语
				langs: 'zh',
				currMenu: 0, //当前选择的产品类型
				scrollNav: false, //浏览器滚动
				navShow: true, //是否显示导航栏
				clickShow: false,
				showmenus: true, //是否展示类别导航
				lists: [],
				lists1: [
					{id:1, title:'智能存取柜', desc:'', size:24, buylink:'https://detail.1688.com/offer/618577193713.html?_t=1698978039786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0', children:[
						{id:1, title:'智能快递柜', desc:'', size:4, children:[
							{id:1, title:'智能快递柜', desc:'', zhsize:14, engsize:22, buylink:'https://detail.1688.com/offer/618577193713.html?_t=1698978039786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:2, title:'智能快递柜', desc:'', zhsize:13, engsize:12, buylink:'https://detail.1688.com/offer/618577193713.html?_t=1698978039786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:3, title:'智能快递柜', desc:'', zhsize:12, engsize:16, buylink:'https://detail.1688.com/offer/618577193713.html?_t=1698978039786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:4, title:'智能快递柜', desc:'1', zhsize:20, engsize:0, buylink:'https://detail.1688.com/offer/618577193713.html?_t=1698978039786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
						]},
						{id:2, title:'智能存包柜', desc:'', size:4, children:[
							{id:1, title:'智能存包柜', desc:'', zhsize:13, engsize:13, buylink:'https://detail.1688.com/offer/615427489158.html?_t=1698978087098&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:2, title:'智能存包柜', desc:'', zhsize:11, engsize:9, buylink:'https://detail.1688.com/offer/615427489158.html?_t=1698978087098&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:3, title:'智能存包柜', desc:'', zhsize:8, engsize:8, buylink:'https://detail.1688.com/offer/615427489158.html?_t=1698978087098&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
							{id:4, title:'智能存包柜', desc:'', zhsize:21, engsize:21, buylink:'https://detail.1688.com/offer/615427489158.html?_t=1698978087098&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
						]},
						{id:3, title:'智能存餐柜', desc:'', size:6, children:[
							{id:1, title:'智能存餐柜', desc:'', zhsize:17, engsize:17, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'智能存餐柜', desc:'', zhsize:14, engsize:14, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:3, title:'智能存餐柜', desc:'', zhsize:14, engsize:14, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:4, title:'智能存餐柜', desc:'', zhsize:16, engsize:16, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:5, title:'智能存餐柜', desc:'', zhsize:22, engsize:22, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:6, title:'智能存餐柜', desc:'', zhsize:12, engsize:12, buylink:'https://detail.1688.com/offer/682667987472.html?_t=1698978139019&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:4, title:'智能洗衣柜', desc:'', size:4, children:[
							{id:1, title:'智能洗衣柜', desc:'', zhsize:12, engsize:11, buylink:'https://detail.1688.com/offer/683152037014.html?_t=1698978175100&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'智能洗衣柜', desc:'', zhsize:23, engsize:17, buylink:'https://detail.1688.com/offer/683152037014.html?_t=1698978175100&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:3, title:'智能洗衣柜', desc:'', zhsize:23, engsize:7, buylink:'https://detail.1688.com/offer/683152037014.html?_t=1698978175100&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:4, title:'头盔干洗柜', desc:'', zhsize:15, engsize:15, buylink:''},
						]},
						{id:5, title:'称重物料柜', desc:'', size:4, children:[
							{id:1, title:'称重物料柜', desc:'', zhsize:15, engsize:14, buylink:'https://detail.1688.com/offer/738792450068.html?_t=1698978186921&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'称重物料柜', desc:'', zhsize:9, engsize:9, buylink:'https://detail.1688.com/offer/738792450068.html?_t=1698978186921&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:3, title:'称重物料柜', desc:'', zhsize:12, engsize:12, buylink:'https://detail.1688.com/offer/738792450068.html?_t=1698978186921&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:4, title:'称重物料柜', desc:'', zhsize:13, engsize:13, buylink:'https://detail.1688.com/offer/738792450068.html?_t=1698978186921&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:6, title:'智能洗鞋柜', desc:'', size:1, children:[
							{id:1, title:'智能洗鞋柜', desc:'', zhsize:8, engsize:10, buylink:'https://detail.1688.com/offer/681109135731.html?_t=1678157464531&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:7, title:'运动器材柜', desc:'', size:1, children:[
							{id:1, title:'运动器材柜', desc:'', zhsize:13, engsize:13, buylink:'https://detail.1688.com/offer/673959692239.html?_t=1698978227969&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
						]},
					]},
					{id:2, title:'RFID智能柜', desc:'', size:9, children:[
						{id:1, title:'智能工具柜', desc:'', size:1, children:[
							{id:1, title:'智能工具柜', desc:'', zhsize:11, engsize:9, buylink:'https://detail.1688.com/offer/684167569316.html?_t=1678157694873&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:2, title:'智能手机柜', desc:'', size:1, children:[
							{id:1, title:'智能手机柜', desc:'', zhsize:14, engsize:21, buylink:'https://detail.1688.com/offer/672569906587.html?_t=1698978547786&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:3, title:'智能借书柜', desc:'', size:1, children:[
							{id:1, title:'智能借书柜', desc:'', zhsize:14, engsize:14, buylink:'https://detail.1688.com/offer/590303417182.html?_t=1698978996459&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:4, title:'智能文件柜', desc:'', size:1, children:[
							{id:1, title:'智能文件柜', desc:'', zhsize:14, engsize:0, buylink:'https://detail.1688.com/offer/682719233099.html?spm=a28888.success.results-action.2.7e1f7e924h0ZGf'},
						]},
						{id:5, title:'智能物料柜', desc:'', size:1, children:[
							{id:1, title:'智能物料柜', desc:'', zhsize:17, engsize:0, buylink:'https://detail.1688.com/offer/602257554634.html?_t=1698979311625&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:6, title:'智能物证柜', desc:'', size:1, children:[
							{id:1, title:'智能物证柜', desc:'', zhsize:15, engsize:16, buylink:'https://detail.1688.com/offer/676483868476.html?_t=1698989962660&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_1.0'},
						]},
						{id:7, title:'智能钥匙柜', desc:'', size:3, children:[
							{id:1, title:'智能钥匙柜', desc:'', zhsize:14, engsize:14, buylink:'https://detail.1688.com/offer/664656584829.html?_t=1698979244958&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'智能钥匙柜', desc:'', zhsize:11, engsize:10, buylink:'https://detail.1688.com/offer/664656584829.html?_t=1698979244958&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:3, title:'智能钥匙柜', desc:'', zhsize:11, engsize:10, buylink:''},
						]},
					]},
					{id:3, title:'智能售货机', desc:'', size:18, children:[
						{id:1, title:'智能售货机', desc:'', size:5, children:[
							{id:1, title:'Y轴售货机', desc:'', zhsize:11, engsize:9, buylink:'https://detail.1688.com/offer/731821509583.html?_t=1698990017316&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:2, title:'Y轴售货机', desc:'', zhsize:11, engsize:11, buylink:'https://detail.1688.com/offer/731821509583.html?_t=1698990017316&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:3, title:'粉色Y轴售货机', desc:'', zhsize:15, engsize:15, buylink:''},
                {id:4, title:'XY轴售货机', desc:'', zhsize:9, engsize:9, buylink:''},
                {id:5, title:'XY轴售货机', desc:'', zhsize:22, engsize:21, buylink:''},
						]},
						{id:2, title:'格子售货机', desc:'', size:4, children:[
							{id:1, title:'格子售货机', desc:'', zhsize:12, engsize:13, buylink:'https://detail.1688.com/offer/674678270424.html?_t=1698979043482&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'格子售货机', desc:'', zhsize:11, engsize:0, buylink:'https://detail.1688.com/offer/674678270424.html?_t=1698979043482&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:3, title:'格子售货机', desc:'', zhsize:16, engsize:7, buylink:'https://detail.1688.com/offer/674678270424.html?_t=1698979043482&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                {id:4, title:'格子售货机', desc:'', zhsize:17, engsize:18, buylink:''},
						]},
						{id:3, title:'履带售货机', desc:'', size:1, children:[
							{id:1, title:'履带售货机', desc:'', zhsize:11, engsize:0, buylink:'https://detail.1688.com/offer/728820067096.html?_t=1698990119884&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:4, title:'社区福利柜', desc:'', size:1, children:[
							{id:1, title:'社区福利柜', desc:'', zhsize:12, engsize:0, buylink:'https://detail.1688.com/offer/680706679203.html?_t=1698990258799&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:5, title:'无屏可视售货机', desc:'', size:1, children:[
							{id:1, title:'无屏可视售货机', desc:'', zhsize:14, engsize:7, buylink:'https://detail.1688.com/offer/622897951292.html?_t=1698990032107&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
						{id:6, title:'智能药品柜', desc:'', size:1, children:[
							{id:1, title:'智能药品柜', desc:'', zhsize:6, engsize:6, buylink:'https://detail.1688.com/offer/676607748224.html?_t=1698990189316&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]},
              {id:7, title:'智能口罩售卖机', desc:'', size:1, children:[
                  {id:1, title:'智能口罩售卖机', desc:'', zhsize:8, engsize:0, buylink:'https://detail.1688.com/offer/670717892461.html?_t=1698990051435&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
                ]},
              {id:8, title:'智能售货机', desc:'', size:1, children:[
                  {id:1, title:'双货道售货机', desc:'', zhsize:15, engsize:15, buylink:''},
                  {id:2, title:'迷你售货机', desc:'', zhsize:10, engsize:12, buylink:''},
                  {id:3, title:'卡片机', desc:'', zhsize:8, engsize:8, buylink:''},
                  {id:4, title:'32吋一体机售货机', desc:'', zhsize:12, engsize:4, buylink:''},
                ]},
					]},
					{id:4, title:'智能一体机', desc:'', size:12, children:[
						{ id:1, title:'智能一体机', desc:'', size:12, children:[
							{id:1, title:'7吋一体机', desc:'', zhsize:16, engsize:12, buylink:'https://detail.1688.com/offer/570708361891.html?_t=1698809379258&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'10.1吋一体机', desc:'1', zhsize:12, engsize:12, buylink:'https://detail.1688.com/offer/681133132578.html?_t=1678158870612&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:3, title:'12.1吋一体机', desc:'1', zhsize:0, engsize:0, buylink:'https://detail.1688.com/offer/677439396363.html?_t=1678159023736&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:4, title:'15吋一体机', desc:'', zhsize:19, engsize:0, buylink:'https://detail.1688.com/offer/619037072817.html?_t=1698809629651&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:5, title:'15.6吋一体机', desc:'', zhsize:17, engsize:0, buylink:'https://detail.1688.com/offer/619865647138.html?_t=1698809669234&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:6, title:'17吋一体机', desc:'', zhsize:17, engsize:0, buylink:'https://detail.1688.com/offer/598375452783.html?_t=1698809940931&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:7, title:'18.5吋一体机', desc:'1', zhsize:13, engsize:0, buylink:'https://szupus.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0'},
							{id:8, title:'19吋一体机', desc:'1', zhsize:12, engsize:0, buylink:'https://szupus.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0'},
							{id:9, title:'21.5吋一体机', desc:'', zhsize:14, engsize:0, buylink:'https://detail.1688.com/offer/588110604548.html?_t=1698809970209&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:10, title:'23.6吋一体机', desc:'', zhsize:15, engsize:0, buylink:'https://detail.1688.com/offer/619866047252.html?_t=1698809999544&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:11, title:'27吋一体机', desc:'1', zhsize:13, engsize:0, buylink:'https://szupus.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0'},
							{id:12, title:'32吋一体机', desc:'', zhsize:15, engsize:0, buylink:'https://detail.1688.com/offer/619866047352.html?_t=1698809306338&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]}
					]},
					{id:5, title:'IoT控制板', desc:'', size:21, children:[
						{id:1, title:'IoT控制板', desc:'', size:21, children:[
							{id:1, title:'2号锁控板带灯控', desc:'', zhsize:13, engsize:0, buylink:'https://detail.1688.com/offer/746547639240.html?spm=a28888.success.results-action.2.55307e92slk0R4'},
							{id:2, title:'8路锁控板', desc:'', zhsize:12, engsize:0, buylink:'https://detail.1688.com/offer/675675365742.html?_t=1698817725238&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:3, title:'8路电机板', desc:'', zhsize:13, engsize:0, buylink:'https://detail.1688.com/offer/616742393515.html?_t=1698817694607&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:4, title:'12路锁控板', desc:'1', zhsize:13, engsize:0, buylink:''},
							{id:5, title:'12路锁控板带灯', desc:'', zhsize:14, engsize:0, buylink:'https://detail.1688.com/offer/624138896199.html?_t=1698817833007&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:6, title:'12路锁控板带正反限位', desc:'', zhsize:15, engsize:0, buylink:'https://detail.1688.com/offer/670794700583.html?_t=1698817862591&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:7, title:'15路锁控板', desc:'1', zhsize:12, engsize:0, buylink:'https://detail.1688.com/offer/675991562751.html?_t=1678171682816&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:8, title:'18路锁控板', desc:'', zhsize:13, engsize:0, buylink:'https://detail.1688.com/offer/671385038957.html?_t=1698817910720&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:9, title:'25路锁控板带灯', desc:'', zhsize:15, engsize:0, buylink:'https://detail.1688.com/offer/730324455789.html?_t=1698817999919&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:10, title:'25路锁控板', desc:'1', zhsize:12, engsize:0, buylink:'https://detail.1688.com/offer/676376683042.html?_t=1678171767441&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:11, title:'27路锁控板', desc:'', zhsize:15, engsize:0, buylink:'https://detail.1688.com/offer/659228315602.html?_t=1698818033617&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:12, title:'50路锁控板', desc:'', zhsize:7, engsize:0, buylink:'https://detail.1688.com/offer/616742393280.html?_t=1698820960287&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:13, title:'多功能锁控板', desc:'', zhsize:12, engsize:0, buylink:'https://detail.1688.com/offer/667879991189.html?_t=1698824011128&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:14, title:'继电器控制板', desc:'', zhsize:10, engsize:0, buylink:'https://detail.1688.com/offer/681251829814.html?_t=1698977935763&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
              {id:15, title:'8路温控板', desc:'', zhsize:10, engsize:0, buylink:'https://detail.1688.com/offer/673261377200.html?_t=1698822815985&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
              {id:16, title:'25路称重板', title1:'25路称重板', desc:'', zhsize:12, engsize:12, spsize:14, buylink:''},
              {id:17, title:'36路锁控板', title1:'36路锁控板', desc:'', zhsize:15, engsize:15, spsize:13, buylink:''},
              {id:18, title:'XYZ控制板', title1:'XYZ控制板', desc:'', zhsize:13, engsize:12, spsize:11, buylink:''},
              {id:19, title:'充电板', title1:'充电板', desc:'', zhsize:11, engsize:11, spsize:11, buylink:''},
              {id:20, title:'电控板', title1:'电控板', desc:'', zhsize:15, engsize:15, spsize:14, buylink:''},
              {id:21, title:'屏控板', title1:'屏控板', desc:'', zhsize:13, engsize:13, spsize:0, buylink:''},
						]}
					]},
					{id:6, title:'数据透传模块', desc:'', size:4, children:[
						{id:1, title:'数据透传模块', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'1', zhsize:13, engsize:13, buylink:'https://detail.1688.com/offer/675082967084.html?_t=1678160216954&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:2, title:'4G DTU-6.0', desc:'', zhsize:13, engsize:13, buylink:'https://detail.1688.com/offer/630004027747.html?_t=1698978284954&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:3, title:'RJ45 DTU', desc:'', zhsize:8, engsize:0, buylink:'https://detail.1688.com/offer/725723080943.html?_t=1698822784422&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
							{id:4, title:'WiFi DTU', desc:'', zhsize:8, engsize:8, buylink:'https://detail.1688.com/offer/680558305643.html?_t=1698822763710&spm=a2615.7691456.co_1_0_wangpu_score_0_0_0_0_0_0_0000_0.0'},
						]}
					]},
					{id:7, title:'人脸识别终端', desc:'', size:3, children:[
						{id:1, title:'人脸识别终端', desc:'', size:3, children:[
							{id:1, title:'7吋人脸识别终端-平板', desc:'1', zhsize:22, engsize:22, buylink:''},
							{id:2, title:'7吋人脸识别终端-圆柱', desc:'1', zhsize:19, engsize:19, buylink:''},
							{id:3, title:'8吋人脸识别终端', desc:'1', zhsize:16, engsize:16, buylink:''},
						]}
					]},
				],
				lists2: [
					{id:1, title:'Smart Access Cabinet', desc:'', size:24, children:[
						{id:1, title:'Smart express cabinet', desc:'', size:4, children:[
							{id:1, title:'Smart express cabinet', desc:'', zhsize:14, engsize:22, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Smart express cabinet', desc:'', zhsize:13, engsize:12, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Smart express cabinet', desc:'', zhsize:12, engsize:16, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Smart express cabinet', desc:'1', zhsize:20, engsize:0, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:2, title:'Smart locker cabinet', desc:'', size:4, children:[
							{id:1, title:'Smart locker cabinet', desc:'', zhsize:13, engsize:13, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Smart locker cabinet', desc:'', zhsize:11, engsize:9, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Smart locker cabinet', desc:'', zhsize:8, engsize:8, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Smart locker cabinet', desc:'', zhsize:21, engsize:21, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:3, title:'Smart save meal cabinet', desc:'', size:6, children:[
							{id:1, title:'Smart save meal cabinet', desc:'', zhsize:17, engsize:17, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Smart save meal cabinet', desc:'', zhsize:14, engsize:14, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Smart save meal cabinet', desc:'', zhsize:14, engsize:14, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Smart save meal cabinet', desc:'', zhsize:11, engsize:0, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:5, title:'Smart save meal cabinet', desc:'', zhsize:22, engsize:22, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:6, title:'Smart save meal cabinet', desc:'', zhsize:12, engsize:12, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:4, title:'Smart washing cabinet', desc:'', size:3, children:[
							{id:1, title:'Smart washing cabinet', desc:'', zhsize:12, engsize:11, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Smart washing cabinet', desc:'', zhsize:23, engsize:17, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Smart washing cabinet', desc:'', zhsize:23, engsize:7, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:4, title:'Helmet dry cleaning cabinet', desc:'', zhsize:15, engsize:15, title1:'头盔干洗柜', buylink:''},
						]},
						{id:5, title:'Weighing material cabinet', desc:'', size:3, children:[
							{id:1, title:'Weighing material cabinet', desc:'', zhsize:15, engsize:14, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Weighing material cabinet', desc:'', zhsize:9, engsize:9, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Weighing material cabinet', desc:'', zhsize:12, engsize:12, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:4, title:'Weighing material cabinet', desc:'', zhsize:13, engsize:13, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},

						]},
						{id:6, title:'Smart shoe washing cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart shoe washing cabinet', desc:'', zhsize:8, engsize:10, title1:'智能洗鞋柜', buylink:'https://www.alibaba.com/product-detail/2023-Smart-Automatic-shoe-mart-Card_1600658572249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:7, title:'Sports equipment cabinet', desc:'', size:1, children:[
							{id:1, title:'Sports equipment cabinet', desc:'', zhsize:13, engsize:13, title1:'运动器材柜', buylink:'https://www.alibaba.com/product-detail/Staff-electronic-smart-RFID-locker-system_1600526709095.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
					]},
					{id:2, title:'RFID Smart Cabinet', desc:'', size:9, children:[
						{id:1, title:'Smart tool cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart tool cabinet', desc:'', zhsize:11, engsize:9, title1:'智能工具柜', buylink:'https://www.alibaba.com/product-detail/2023-UHF-RFID-material-smart-storage_1600278354249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:2, title:'Smart phone cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart phone cabinet', desc:'', zhsize:14, engsize:21, title1:'智能手机柜', buylink:'https://www.alibaba.com/product-detail/Hot-sale-RFID-smart-cat-key_1600294144306.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:3, title:'Smart borrow bookcase', desc:'', size:1, children:[
							{id:1, title:'Smart borrow bookcase', desc:'', zhsize:14, engsize:14, title1:'智能借书柜', buylink:'https://www.alibaba.com/product-detail/Smart-bookcase-vending-machine-smart-book_62106197300.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
						]},
						{id:4, title:'Smart file cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart file cabinet', desc:'', zhsize:14, engsize:0, title1:'智能文件柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
						]},
						{id:5, title:'Smart material cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart material cabinet', desc:'', zhsize:17, engsize:0, title1:'智能物料柜', buylink:'https://www.alibaba.com/product-detail/2023-UHF-RFID-material-smart-storage_1600278354249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:6, title:'Smart evidence cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart evidence cabinet', desc:'1', zhsize:15, engsize:16, title1:'智能物证柜', buylink:''},
						]},
						{id:7, title:'Smart key cabinet', desc:'', size:3, children:[
							{id:1, title:'Smart key cabinet', desc:'', zhsize:14, engsize:14, title1:'智能钥匙柜', buylink:'https://www.alibaba.com/product-detail/Factory-sale-directly-intelligent-car-key_1600383412369.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
							{id:2, title:'Smart key cabinet', desc:'', zhsize:11, engsize:10, title1:'智能钥匙柜', buylink:'https://www.alibaba.com/product-detail/Factory-sale-directly-intelligent-car-key_1600383412369.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Smart key cabinet', desc:'', zhsize:11, engsize:10, title1:'智能钥匙柜', buylink:''},
						]},
					]},
					{id:3, title:'Smart Vending Machine', desc:'', size:18, children:[
						{id:1, title:'Y-axis vending machine', desc:'', size:5, children:[
                {id:1, title:'Y-axis vending machine', desc:'', zhsize:11, engsize:9, title1:'y轴售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:2, title:'Y-axis vending machine', desc:'', zhsize:11, engsize:11, title1:'y轴售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Pink Y-axis vending machine', desc:'', zhsize:15, engsize:15, title1:'粉色y轴售货机', buylink:''},
                {id:4, title:'XY-axis vending machine', title1:'XY轴售货机', desc:'', zhsize:9, engsize:9, buylink:''},
                {id:5, title:'XY-axis vending machine', title1:'XY轴售货机', desc:'', zhsize:22, engsize:21, buylink:''},
						]},
						{id:2, title:'Grid vending machine', desc:'', size:4, children:[
							{id:1, title:'Grid vending machine', desc:'', zhsize:12, engsize:13, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
							{id:2, title:'Grid vending machine', desc:'', zhsize:11, engsize:0, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Grid vending machine', desc:'', zhsize:16, engsize:7, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/24-hour-vending-machines-for-vending_1600921640017.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
                {id:4, title:'Grid vending machine', desc:'', zhsize:17, engsize:18, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/24-hour-vending-machines-for-vending_1600921640017.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
						]},
						{id:3, title:'Crawler vending machine', desc:'', size:1, children:[
							{id:1, title:'Crawler vending machine', desc:'', zhsize:11, engsize:0, title1:'履带售货机', buylink:'https://www.alibaba.com/product-detail/24hour-Elevator-vending-machine-vending-machine_1600951084732.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]},
						{id:4, title:'Community welfare counter', desc:'', size:1, children:[
							{id:1, title:'Community welfare counter', desc:'1', zhsize:12, engsize:0, title1:'社区福利柜', buylink:''},
						]},
						{id:5, title:'No screen visual vending machine', desc:'', size:1, children:[
							{id:1, title:'No screen visual vending machine', desc:'', zhsize:14, engsize:7, title1:'无屏可视售货机', buylink:'https://www.alibaba.com/product-detail/24hour-Elevator-vending-machine-vending-machine_1600951084732.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]},
						{id:6, title:'Smart medicine cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart medicine cabinet', desc:'1', zhsize:6, engsize:6, title1:'智能药品柜', buylink:''},
						]},
						{id:7, title:'Smart mask vending machine', desc:'', size:1, children:[
							{id:1, title:'Smart mask vending machine', desc:'1', zhsize:8, engsize:0, title1:'智能口罩售卖机', buylink:''},
						]},
              {id:8, title:'Smart vending machine', desc:'', size:4, children:[
                  {id:1, title:'Double aisle vending machine', desc:'', zhsize:15, engsize:15, title1:'双货道售货机', buylink:''},
                  {id:2, title:'mini vending machine', desc:'', zhsize:10, engsize:12, title1:'迷你售货机', buylink:''},
                  {id:3, title:'Card machine', desc:'', zhsize:8, engsize:8, title1:'卡片机', buylink:''},
                  {id:4, title:'32-inch all-in-one vending machine', title1:'32吋一体机售货机', desc:'', zhsize:12, engsize:4, buylink:''},
                ]},
					]},
					{id:4, title:'Smart all-in-one machine', desc:'', size:12, children:[
						{ id:1, title:'Smart all-in-one machine', desc:'', size:12, children:[
							{id:1, title:'7 "All-in-one', desc:'', zhsize:16, engsize:0, title1:'7吋一体机', buylink:'https://www.alibaba.com/product-detail/7-inch-all-in-one-pc_1600524901705.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'10.1 "All-in-one', desc:'', zhsize:12, engsize:12, title1:'10.1吋一体机', buylink:'https://www.alibaba.com/product-detail/10-1-inch-android-industrial-pc_1600112741032.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:3, title:'12.1 "All-in-one', desc:'1', zhsize:13, engsize:0, title1:'12.1吋一体机', buylink:''},
							{id:4, title:'15 "All-in-one', desc:'1', zhsize:19, engsize:0, title1:'15吋一体机', buylink:''},
							{id:5, title:'15.6 "All-in-one', desc:'', zhsize:17, engsize:0, title1:'15.6吋一体机', buylink:'https://www.alibaba.com/product-detail/10-1-inch-android-industrial-pc_1600112741032.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:6, title:'17 "All-in-one', desc:'', zhsize:17, engsize:0, title1:'17吋一体机', buylink:'https://www.alibaba.com/product-detail/17-inch-all-in-one-pc_1600116403929.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:7, title:'18.5 "All-in-one', desc:'1', zhsize:13, engsize:0, title1:'18.5吋一体机', buylink:''},
							{id:8, title:'19 "All-in-one', desc:'1', zhsize:12, engsize:0, title1:'19吋一体机', buylink:''},
							{id:9, title:'21.5 "All-in-one', desc:'', zhsize:14, engsize:0, title1:'21.5吋一体机', buylink:'https://www.alibaba.com/product-detail/21-5-inch-all-in-one_1600525992000.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:10, title:'23.6 "All-in-one', desc:'', zhsize:15, engsize:0, title1:'23.6吋一体机', buylink:'https://www.alibaba.com/product-detail/21-5-inch-all-in-one_1600525992000.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:11, title:'27 "All-in-one', desc:'1', zhsize:13, engsize:0, title1:'27吋一体机', buylink:''},
							{id:12, title:'32 "All-in-one', desc:'', zhsize:15, engsize:0, title1:'32吋一体机', buylink:'https://www.alibaba.com/product-detail/24hour-locker-vending-machine-vending-machine_1600958573267.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]}
					]},
					{id:5, title:'IoT Control Panel', desc:'', size:21, children:[
						{id:1, title:'IoT Control Panel', desc:'', size:21, children:[
							{id:1, title:'Lock board No. 2 with light control', desc:'', zhsize:14, engsize:0, title1:'2号锁控板带灯控', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'8 way lock control board', desc:'', zhsize:12, engsize:0, title1:'8路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:3, title:'8 Road motor plate', desc:'', zhsize:13, engsize:0, title1:'8路电机板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:4, title:'12 way lock control board', desc:'', zhsize:13, engsize:0, title1:'12路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:5, title:'12 way lock control board with lamp', desc:'', zhsize:14, engsize:0, title1:'12路锁控板带灯', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:6, title:'12 way lock control board With positive and negative limit', desc:'', zhsize:15, engsize:0, title1:'12路锁控板带正反限位', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:7, title:'15 way lock control board', desc:'', zhsize:12, engsize:0, title1:'15路锁控板', buylink:'https://www.alibaba.com/product-detail/Factory-directly-sale-RS485-15-way_1600400294176.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:8, title:'18 way lock control board', desc:'', zhsize:13, engsize:0, title1:'18路锁控板', buylink:'https://www.alibaba.com/product-detail/12-18-25-36-channel-RS485_1600613268852.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:9, title:'25 way lock control board with lamp', desc:'', zhsize:15, engsize:0, title1:'25路锁控板带灯', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:10, title:'25 way lock control board', desc:'', zhsize:12, engsize:0, title1:'25路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:11, title:'27 way lock control board', desc:'', zhsize:15, engsize:0, title1:'27路锁控板', buylink:'https://www.alibaba.com/product-detail/High-quality-27-way-RS485-access_1600301361589.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:12, title:'50 way lock control board', desc:'', zhsize:7, engsize:0, title1:'50路锁控板', buylink:'https://www.alibaba.com/product-detail/Factory-directly-sell-50-channels-lock_1600542440046.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:13, title:'Multi-function lock control board', desc:'1', zhsize:12, engsize:0, title1:'多功能锁控板', buylink:''},
							{id:14, title:'Relay control panel', desc:'1', zhsize:10, engsize:0, title1:'继电器控制板', buylink:''},
							{id:15, title:'8 way temperature control board', desc:'1', zhsize:10, engsize:0, title1:'8路温控板', buylink:''},
              {id:16, title:'25-way weighing board', title1:'25路称重板', desc:'', zhsize:12, engsize:12, spsize:14, buylink:''},
              {id:17, title:'36-way lock control board', title1:'36路锁控板', desc:'', zhsize:15, engsize:15, spsize:13, buylink:''},
              {id:18, title:'XYZ control panel', title1:'XYZ控制板', desc:'', zhsize:13, engsize:12, spsize:11, buylink:''},
              {id:19, title:'Charging board', title1:'充电板', desc:'', zhsize:11, engsize:11, spsize:11, buylink:''},
              {id:20, title:'Electrical control panel', title1:'电控板', desc:'', zhsize:15, engsize:15, spsize:14, buylink:''},
              {id:21, title:'Screen control panel', title1:'屏控板', desc:'', zhsize:13, engsize:13, spsize:0, buylink:''},
						]}
					]},
					{id:6, title:'Data passthrough module', desc:'', size:4, children:[
						{id:1, title:'Data passthrough module', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'', zhsize:13, engsize:13, title1:'', buylink:'https://www.alibaba.com/product-detail/4G-module-for-IoT-dedicatedly-50Mbps_1600973861528.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'4G DTU-6.0', desc:'', zhsize:13, engsize:13, title1:'', buylink:''},
							{id:3, title:'RJ45 DTU', desc:'', zhsize:8, engsize:0, title1:'', buylink:''},
							{id:4, title:'WiFi DTU', desc:'', zhsize:8, engsize:8, title1:'', buylink:''},
						]}
					]},
					{id:7, title:'Face recognition terminal', desc:'', size:3, children:[
						{id:1, title:'Face recognition terminal', desc:'', size:3, children:[
							{id:1, title:'7 "face recognition terminal - tablet', desc:'1', zhsize:22, engsize:22, title1:'7吋人脸考勤机-平板', buylink:''},
							{id:2, title:'7 "face recognition terminal - cylindrical', desc:'', zhsize:19, engsize:19, title1:'7吋人脸考勤机-圆柱', buylink:'https://www.alibaba.com/product-detail/face-recognition-temperature-detect-access-control_62570323699.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:3, title:'8 "face recognition terminal', desc:'1', zhsize:16, engsize:16, title1:'8吋人脸考勤机', buylink:''},
						]}
					]},
				],
				lists3: [
					{id:1, title:'Acceso Inteligente', desc:'', size:24, children:[
						{id:1, title:'Gabinete Express Inteligente', desc:'', size:4, children:[
							{id:1, title:'Gabinete Express Inteligente', desc:'', zhsize:14, engsize:22, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Gabinete Express Inteligente', desc:'', zhsize:13, engsize:12, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Gabinete Express Inteligente', desc:'', zhsize:12, engsize:16, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Gabinete Express Inteligente', desc:'', zhsize:20, engsize:0, title1:'智能快递柜', buylink:'https://www.alibaba.com/product-detail/smart-cabinet-smart-parcel-locker-Smart_62104101632.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:2, title:'Gabinete Inteligente de almacenamiento de bolsas', desc:'', size:4, children:[
							{id:1, title:'Gabinete Inteligente de almacenamiento de bolsas', desc:'', zhsize:13, engsize:13, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Gabinete Inteligente de almacenamiento de bolsas', desc:'', zhsize:11, engsize:9, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Gabinete Inteligente de almacenamiento de bolsas', desc:'', zhsize:8, engsize:8, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Gabinete Inteligente de almacenamiento de bolsas', desc:'', zhsize:21, engsize:21, title1:'智能存包柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:3, title:'Gabinete inteligente para comida', desc:'', size:6, children:[
							{id:1, title:'Gabinete inteligente para comida', desc:'', zhsize:17, engsize:17, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Gabinete inteligente para comida', desc:'', zhsize:14, engsize:14, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Gabinete inteligente para comida', desc:'', zhsize:14, engsize:14, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:4, title:'Gabinete inteligente para comida', desc:'', zhsize:16, engsize:16, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:5, title:'Gabinete inteligente para comida', desc:'', zhsize:22, engsize:22, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:6, title:'Gabinete inteligente para comida', desc:'', zhsize:12, engsize:12, title1:'智能存餐柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:4, title:'Gabinete para lavanderia inteligente', desc:'', size:4, children:[
							{id:1, title:'Gabinete para lavanderia inteligente', desc:'', zhsize:12, engsize:11, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Gabinete para lavanderia inteligente', desc:'', zhsize:23, engsize:17, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Gabinete para lavanderia inteligente', desc:'', zhsize:23, engsize:7, title1:'智能洗衣柜', buylink:'https://www.alibaba.com/product-detail/new-style-smart-laundry-locker-smart_62105553753.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:4, title:'Armario de limpieza en seco para cascos.', desc:'', zhsize:15, engsize:15, title1:'头盔干洗柜', buylink:''},
						]},
						{id:5, title:'Gabinete de material de pesaje', desc:'', size:4, children:[
							{id:1, title:'Gabinete de material de pesaje', desc:'', zhsize:15, engsize:14, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:2, title:'Gabinete de material de pesaje', desc:'', zhsize:9, engsize:9, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
							{id:3, title:'Gabinete de material de pesaje', desc:'', zhsize:12, engsize:12, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
                {id:4, title:'Gabinete de material de pesaje', desc:'', zhsize:13, engsize:13, title1:'称重物料柜', buylink:'https://www.alibaba.com/product-detail/Pad-Lock-Holder-Or-Cam-Lock_1600930911529.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:6, title:'Gabinete de lavado de zapatos inteligente', desc:'', size:1, children:[
							{id:1, title:'Gabinete de lavado de zapatos inteligente', desc:'', zhsize:8, engsize:10, title1:'智能洗鞋柜', buylink:'https://www.alibaba.com/product-detail/2023-Smart-Automatic-shoe-mart-Card_1600658572249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:7, title:'Gabinete de equipamiento deportivo', desc:'', size:1, children:[
							{id:1, title:'Gabinete de equipamiento deportivo', desc:'', zhsize:13, engsize:13, title1:'运动器材柜', buylink:'https://www.alibaba.com/product-detail/Staff-electronic-smart-RFID-locker-system_1600526709095.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
					]},
					{id:2, title:'Gabinete inteligente RFID', desc:'', size:9, children:[
						{id:1, title:'Gabinete de herramientas inteligente', desc:'', size:1, children:[
							{id:1, title:'Gabinete de herramientas inteligente', desc:'', zhsize:11, engsize:9, title1:'智能工具柜', buylink:'https://www.alibaba.com/product-detail/2023-UHF-RFID-material-smart-storage_1600278354249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:2, title:'Gabinete de mano inteligente', desc:'', size:1, children:[
							{id:1, title:'Gabinete de mano inteligente', desc:'', zhsize:14, engsize:21, title1:'智能手机柜', buylink:'https://www.alibaba.com/product-detail/Hot-sale-RFID-smart-cat-key_1600294144306.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:3, title:'Biblioteca de préstamo inteligente', desc:'', size:1, children:[
							{id:1, title:'Biblioteca de préstamo inteligente', desc:'', zhsize:14, engsize:14, title1:'智能借书柜', buylink:'https://www.alibaba.com/product-detail/Smart-bookcase-vending-machine-smart-book_62106197300.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
						]},
						{id:4, title:'Archivador inteligente', desc:'', size:1, children:[
							{id:1, title:'Archivador inteligente', desc:'', zhsize:14, engsize:0, title1:'智能文件柜', buylink:'https://www.alibaba.com/product-detail/Customized-intelligent-express-cabinet-smart-parcel_1600210288507.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
						]},
						{id:5, title:'Gabinete de materiales inteligente', desc:'', size:1, children:[
							{id:1, title:'Gabinete de materiales inteligente', desc:'', zhsize:17, engsize:0, title1:'智能物料柜', buylink:'https://www.alibaba.com/product-detail/2023-UHF-RFID-material-smart-storage_1600278354249.html?spm=a2747.manage.0.0.217471d2nimuxj'},
						]},
						{id:6, title:'Gabinete de evidencia física inteligente', desc:'1', size:1, children:[
							{id:1, title:'Gabinete de evidencia física inteligente', desc:'', zhsize:15, engsize:16, title1:'智能物证柜', buylink:''},
						]},
						{id:7, title:'Gabinete con llave inteligente', desc:'', size:3, children:[
							{id:1, title:'Gabinete con llave inteligente', desc:'', zhsize:14, engsize:14, title1:'智能钥匙柜', buylink:'https://www.alibaba.com/product-detail/Factory-sale-directly-intelligent-car-key_1600383412369.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
							{id:2, title:'Gabinete con llave inteligente', desc:'', zhsize:11, engsize:10, title1:'智能钥匙柜', buylink:'https://www.alibaba.com/product-detail/Factory-sale-directly-intelligent-car-key_1600383412369.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Gabinete con llave inteligente', desc:'', zhsize:11, engsize:10, title1:'智能钥匙柜', buylink:''},
						]},
					]},
					{id:3, title:'Máquina vending inteligente', desc:'', size:18, children:[
						{id:1, title:'Máquina expendedora del eje y', desc:'', size:5, children:[
                {id:1, title:'Máquina expendedora del eje y', desc:'', zhsize:11, engsize:9, title1:'y轴售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:2, title:'Máquina expendedora del eje y', desc:'', zhsize:11, engsize:11, title1:'y轴售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Máquina expendedora rosa del eje y', desc:'', zhsize:15, engsize:15, title1:'粉色y轴售货机', buylink:''},
                {id:4, title:'Máquina expendedora del eje xy', title1:'XY轴售货机', desc:'', zhsize:9, engsize:9, buylink:''},
                {id:5, title:'Máquina expendedora del eje xy', title1:'XY轴售货机', desc:'', zhsize:22, engsize:21, buylink:''},
						]},
						{id:2, title:'Máquina expendedora', desc:'', size:4, children:[
							{id:1, title:'Máquina expendedora', desc:'', zhsize:12, engsize:13, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
							{id:2, title:'Máquina expendedora', desc:'', zhsize:11, engsize:0, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/Europe-24-hour-unmanned-pink-beauty_1600861575273.html?spm=a2747.manage.0.0.6d0f71d2rUr21t'},
                {id:3, title:'Máquina expendedora', desc:'', zhsize:16, engsize:7, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/24-hour-vending-machines-for-vending_1600921640017.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
                {id:4, title:'Máquina expendedora', desc:'', zhsize:17, engsize:18, title1:'格子售货机', buylink:'https://www.alibaba.com/product-detail/24-hour-vending-machines-for-vending_1600921640017.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
						]},
						{id:3, title:'Máquina expendedora de orugas', desc:'', size:1, children:[
							{id:1, title:'Máquina expendedora de orugas', desc:'', zhsize:11, engsize:0, title1:'履带售货机', buylink:'https://www.alibaba.com/product-detail/24hour-Elevator-vending-machine-vending-machine_1600951084732.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]},
						{id:4, title:'Gabinete de beneficios comunitarios', desc:'1', size:1, children:[
							{id:1, title:'Gabinete de beneficios comunitarios', desc:'', zhsize:12, engsize:0, title1:'社区福利柜', buylink:''},
						]},
						{id:5, title:'Vending visual sin pantalla', desc:'', size:1, children:[
							{id:1, title:'Vending visual sin pantalla', desc:'', zhsize:14, engsize:7, title1:'无屏可视售货机', buylink:'https://www.alibaba.com/product-detail/24hour-Elevator-vending-machine-vending-machine_1600951084732.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]},
						{id:6, title:'Gabinete farmacéutico inteligente', desc:'1', size:1, children:[
							{id:1, title:'Gabinete farmacéutico inteligente', desc:'', zhsize:6, engsize:6, title1:'智能药品柜', buylink:''},
						]},
              {id:7, title:'Mascarilla inteligente vending machine', desc:'1', size:1, children:[
                  {id:1, title:'Mascarilla inteligente vending machine', desc:'', zhsize:8, engsize:0, title1:'智能口罩售卖机', buylink:''},
                ]},
              {id:8, title:'Máquina expendedora inteligente', desc:'', size:4, children:[
                  {id:1, title:'Máquina expendedora de doble pasillo', desc:'', zhsize:15, title1:'双货道售货机', engsize:15, buylink:''},
                  {id:2, title:'mini máquina expendedora', desc:'', zhsize:10, engsize:12, title1:'迷你售货机', buylink:''},
                  {id:3, title:'maquina de tarjetas', desc:'', zhsize:8, engsize:8, title1:'卡片机', buylink:''},
                  {id:4, title:'Máquina expendedora todo en uno de 32 pulgadas', title1:'32吋一体机售货机', desc:'', zhsize:12, engsize:4, buylink:''},
                ]},
					]},
					{id:4, title:'Inteligente todo en uno', desc:'', size:12, children:[
						{ id:1, title:'Inteligente todo en uno', desc:'', size:12, children:[
							{id:1, title:'7 "todo en uno', desc:'', zhsize:16, engsize:12, title1:'7吋一体机', buylink:'https://www.alibaba.com/product-detail/7-inch-all-in-one-pc_1600524901705.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'10.1 "todo en uno', desc:'', zhsize:12, engsize:12, title1:'10.1吋一体机', buylink:'https://www.alibaba.com/product-detail/10-1-inch-android-industrial-pc_1600112741032.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:3, title:'12.1 "todo en uno', desc:'1', zhsize:13, engsize:0, title1:'12.1吋一体机', buylink:''},
							{id:4, title:'15 "todo en uno', desc:'1', zhsize:19, engsize:0, title1:'15吋一体机', buylink:''},
							{id:5, title:'15.6 "todo en uno', desc:'', zhsize:17, engsize:0, title1:'15.6吋一体机', buylink:'https://www.alibaba.com/product-detail/10-1-inch-android-industrial-pc_1600112741032.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:6, title:'17 "todo en uno', desc:'', zhsize:17, engsize:0, title1:'17吋一体机', buylink:'https://www.alibaba.com/product-detail/17-inch-all-in-one-pc_1600116403929.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:7, title:'18.5 "todo en uno', desc:'1', zhsize:13, engsize:0, title1:'18.5吋一体机', buylink:''},
							{id:8, title:'19 "todo en uno', desc:'1', zhsize:12, engsize:0, title1:'19吋一体机', buylink:''},
							{id:9, title:'21.5 "todo en uno', desc:'', zhsize:14, engsize:0, title1:'21.5吋一体机', buylink:'https://www.alibaba.com/product-detail/21-5-inch-all-in-one_1600525992000.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:10, title:'23.6 "todo en uno', desc:'', zhsize:15, engsize:0, title1:'23.6吋一体机', buylink:'https://www.alibaba.com/product-detail/21-5-inch-all-in-one_1600525992000.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:11, title:'27 "todo en uno', desc:'1', zhsize:13, engsize:0, title1:'27吋一体机', buylink:''},
							{id:12, title:'32 "todo en uno', desc:'', zhsize:15, engsize:0, title1:'32吋一体机', buylink:'https://www.alibaba.com/product-detail/32-inch-all-in-one-pc_1600116541560.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
						]}
					]},
					{id:5, title:'Placa de control IoT', desc:'', size:21, children:[
						{id:1, title:'Placa de control IoT', desc:'', size:21, children:[
							{id:1, title:'No. 2 tablero de control de bloqueo con control de luz', desc:'', zhsize:14, engsize:0, title1:'2号锁控板带灯控', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'Tablero de control de bloqueo de 8 vías', desc:'', zhsize:12, engsize:0, title1:'8路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:3, title:'Placa del motor de 8 vías', desc:'', zhsize:13, engsize:0, title1:'8路电机板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:4, title:'Tablero de control de bloqueo de 12 vías', desc:'', zhsize:13, engsize:0, title1:'12路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:5, title:'Tablero de control de bloqueo de 12 vías con luz', desc:'', zhsize:14, engsize:0, title1:'12路锁控板带灯', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:6, title:'Tablero de control de bloqueo de 12 vías con límite positivo y negativo', desc:'', zhsize:15, engsize:0, title1:'12路锁控板带正反限位', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:7, title:'Tablero de control de bloqueo de 15 vías', desc:'', zhsize:12, engsize:0, title1:'15路锁控板', buylink:'https://www.alibaba.com/product-detail/Factory-directly-sale-RS485-15-way_1600400294176.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:8, title:'Tablero de control de bloqueo de 18 vías', desc:'', zhsize:13, engsize:0, title1:'18路锁控板', buylink:'https://www.alibaba.com/product-detail/12-18-25-36-channel-RS485_1600613268852.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:9, title:'Panel de control de bloqueo de 25 vías con luz', desc:'', zhsize:15, engsize:0, title1:'25路锁控板带灯', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:10, title:'Panel de control de bloqueo de 25 vías', desc:'', zhsize:12, engsize:0, title1:'25路锁控板', buylink:'https://www.alibaba.com/product-detail/2-way-locker-control-board-smart_1600121955496.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:11, title:'Panel de control de bloqueo de 27 vías', desc:'', zhsize:15, engsize:0, title1:'27路锁控板', buylink:'https://www.alibaba.com/product-detail/High-quality-27-way-RS485-access_1600301361589.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:12, title:'Tablero de control de bloqueo de 50 vías', desc:'', zhsize:7, engsize:0, title1:'50路锁控板', buylink:'https://www.alibaba.com/product-detail/Factory-directly-sell-50-channels-lock_1600542440046.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:13, title:'Tablero de control de bloqueo multifuncional', desc:'1', zhsize:12, engsize:0, title1:'多功能锁控板', buylink:''},
							{id:14, title:'Tablero de control de relés', desc:'1', zhsize:10, engsize:0, title1:'继电器控制板', buylink:''},
							{id:15, title:'Placa de control de temperatura de 8 vías', desc:'1', zhsize:10, engsize:0, title1:'8路温控板', buylink:''},
              {id:16, title:'tabla de pesaje de 25 posiciones', title1:'25路称重板', desc:'', zhsize:12, engsize:12, spsize:14, buylink:''},
              {id:17, title:'Tablero de control de cerradura de 36 vías', title1:'36路锁控板', desc:'', zhsize:15, engsize:15, spsize:13, buylink:''},
              {id:18, title:'Panel de control XYZ', title1:'XYZ控制板', desc:'', zhsize:13, engsize:12, spsize:11, buylink:''},
              {id:19, title:'tablero de carga', title1:'充电板', desc:'', zhsize:11, engsize:11, spsize:11, buylink:''},
              {id:20, title:'Cuadro de control electrico', title1:'电控板', desc:'', zhsize:15, engsize:15, spsize:14, buylink:''},
              {id:21, title:'Panel de control de pantalla', title1:'屏控板', desc:'', zhsize:13, engsize:13, spsize:0, buylink:''},
						]}
					]},
					{id:6, title:'Módulo de transmisión de datos', desc:'', size:4, children:[
						{id:1, title:'Módulo de transmisión de datos', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'', zhsize:13, engsize:13, title1:'', buylink:'https://www.alibaba.com/product-detail/4G-module-for-IoT-dedicatedly-50Mbps_1600973861528.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'4G DTU-6.0', desc:'', zhsize:13, engsize:13, title1:'', buylink:''},
							{id:3, title:'RJ45 DTU', desc:'', zhsize:8, engsize:7, title1:'', buylink:''},
							{id:4, title:'WiFi DTU', desc:'', zhsize:8, engsize:8, title1:'', buylink:''},
						]}
					]},
					{id:7, title:'Terminal de reconocimiento facial', desc:'', size:3, children:[
						{id:1, title:'Terminal de reconocimiento facial', desc:'', size:3, children:[
							{id:1, title:'Terminal de reconocimiento facial 7 "- tablet', desc:'', zhsize:22, engsize:22, title1:'7吋人脸识别终端-平板', buylink:'https://www.alibaba.com/product-detail/4G-module-for-IoT-dedicatedly-50Mbps_1600973861528.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
							{id:2, title:'Terminal de reconocimiento facial 7 "- cylinder', desc:'', zhsize:19, engsize:19, title1:'7吋人脸识别终端-圆柱', buylink:'https://www.alibaba.com/product-detail/face-recognition-temperature-detect-access-control_62570323699.html?spm=a2747.manage.0.0.360871d2MAjzg2'},
							{id:3, title:'Terminal de reconocimiento facial 8"', desc:'', zhsize:16, engsize:16, title1:'8吋人脸识别终端', buylink:'https://www.alibaba.com/product-detail/4G-module-for-IoT-dedicatedly-50Mbps_1600973861528.html?spm=a2747.manage.0.0.705171d2uTwNOK'},
						]}
					]},
				],
			}
		},
		created() {
			let _this = this;
			_this.currMenu = parseInt(_this.$route.query.index);
			// console.info(_this.currMenu);
			if(!_this.currMenu) {
				_this.currMenu = 0;
			}
			setTimeout(() => {
				_this.showLoading = false;
			}, 500);
		},
		mounted() {
			let _this = this;
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
				_this.lists = _this.lists3;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
				_this.lists = _this.lists2;
			} else {
				_this.langs = zh;
				_this.lists = _this.lists1;
			}
			// _this.productList = _this.lists[(_this.currMenu)].children;
      // console.info(_this.productList);
      // let productlangs = _this.lists[(_this.currMenu)].children;
      // console.info(productlangs);


      // console.info(_this.lists[(_this.currMenu)])

      let origin = window.location.origin;
      console.info(origin);
      if(origin == 'http://www.upusiot.cn'||origin == 'https://www.upusiot.cn') {
        for(let m in _this.lists) {
          for(let n in _this.lists[m].children) {
            for(let v in _this.lists[m].children[n].children) {
              _this.lists[m].children[n].children[v].desc = _this.lists2[m].children[n].children[v].desc;
              _this.lists[m].children[n].children[v].buylink = _this.lists2[m].children[n].children[v].buylink;
            }
          }
        }
      } else {
        // console.info('11111')
        // console.info(_this.lists)
        for(let m in _this.lists) {
          console.info(_this.lists[m].children)
          for(let n in _this.lists[m].children) {
            for(let v in _this.lists[m].children[n].children) {
              _this.lists[m].children[n].children[v].desc = _this.lists1[m].children[n].children[v].desc;
              _this.lists[m].children[n].children[v].buylink = _this.lists1[m].children[n].children[v].buylink;
            }
          }
        }
      }
      // console.info(_this.lists[(_this.currMenu)])
      _this.productList = _this.lists[(_this.currMenu)].children;
      // console.info(_this.productList);

      // if(prot == 'http:') {
      //   let newurl = jeeurl.replace(':8443', '');
      //   newurl = newurl.replace(':8091', '');
      //   window.location.href = newurl +'upus';
      // }


			window.addEventListener("scroll", _this.handleScroll);
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log(scrollTop);
				if(scrollTop > 450){
					this.scrollNav = true;
					this.navShow = false;
				}else{
					this.scrollNav = false;
					this.navShow = true;
				}
				this.clickShow = false;
			},
			// 滚动后 -
			showNav() {
				this.clickShow = !this.clickShow;
			},
			// 选择产品类型
			selectCurrNav(index, dindex) {
				let _this = this;
				const loading = _this.$loading({ text:'Loading...', background: 'rgba(0, 0, 0, 0.7)' })
				_this.currMenu = index;
        // console.info(index+'---'+dindex)
        if(dindex == 99) {
          _this.productList = _this.lists[index].children;
        } else {
          _this.productList = _this.lists[index].children[dindex].children;
        }
				// console.info(_this.productList);
				_this.clickShow = false; //隐藏产品nav
				_this.showmenus = true;
				// window.scrollTo(0,0);
				setTimeout(()=> {
					loading.close();
				}, 500)
			},
			scrollToDiv(index) {
				document.getElementById('title'+index).scrollIntoView({ behavior: "smooth", block: "center" });
			},
			showMenus() {
				this.showmenus = !this.showmenus;
			},
		}
	}
</script>

<style scoped>
	.pro-content{
		padding: 20px 0px 60px;
	}
	.el-submenu .el-menu-item{
		padding-left: 60px!important;
	}
	.product-box h4{
		margin: 0px;
		padding: 12px 5px;
		font-size: 18px;
		background-image: linear-gradient(to right, #409EFF, #87CEFA);
		color: #fff;
	}
	.product-box .el-col{
		padding: 5px;
	}
	.product-list{
		background-color: #fff;
		transition: 0.3s;
		padding: 10px;
		min-height: 260px;
    box-shadow: 0px 0px 30px 0px rgb(0 0 0 / 7%);
    border-radius: 5px;
	}
	.product-list:hover{
		box-shadow: 1px 2px 10px #999;
	}
	.dtl-link{
		text-align: right;
    padding: 5px 0px 10px;
	}
	.dtl-btn{
		display: inline-block;
	}
	/* 左侧导航 */
	.nav-menu{
		min-width: 200px;
    min-height: 600px;
		background-color: #fff;
		overflow: hidden;
		position: sticky;
		top: 80px;
    border-radius: 10px;
    box-shadow: 0px 0px 30px 0px rgb(0 0 0 / 7%);
    padding-bottom: 50px;
	}
	.nav-menu-ul li{
		position: relative;
		cursor: pointer;
		transition: 0.3s;
	}
	.menu-list-s:hover{
		background: #ecf5ff;
	}
	.nav-menu-ul i{
		vertical-align: middle;
		margin-right: 5px;
		width: 24px;
		text-align: center;
		font-size: 18px;
		color: #909399;
	}
	.nav-menu-ul i.icon-arrow{
		font-size: 12px;
		transform: rotateZ(-90deg);
		position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -7px;
		transition: 0.5s;
	}
	.menu-title{
		padding: 10px 18px;
		color: #000;
		font-size: 15px;
    font-weight: 600;
	}
  .small-menu-li{
    padding: 5px 30px 2px;
  }
  .iot-number{
    float: right;
    background: #409eff;
    color: #fff;
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 22px;
    text-align: center;
    font-size: 13px;
  }
	.nav-menu-ul .opened{
		color: #000;
	}
  .nav-menu-ul .openeds{
    background: #ecf5ff;
  }
	.x-gh{
		color: #87CEFA;
	}
	.nav-menu-ul .opened  i.icon-arrow{
		transform: rotateZ(270deg);
	}
	@keyframes fadeInDown{
		0% {
		  opacity: 0;
		  -webkit-transform: translateY(-20px);
		  transform: translateY(-20px);
		}
		100% {
		  opacity: 1;
		  -webkit-transform: translateY(0);
		  transform: translateY(0);
		}
	}
	.proScrollTop.isShowNav{
		z-index: 999;
		opacity: 1;
		top: 114px;
	}
	.fixed-nav{
		padding: 12px 5px;
		cursor: pointer;
	}
	.navScrollTop{
		position: fixed;
		top: 70px;
		width: 100%;
		max-width: 100%;
		background-color: #ecf5ff;
		z-index: 999;
		-webkit-animation: fadeInDown .3s;
		animation: fadeInDown .3s;
		box-shadow: 0px 5px 10px #999;
	}
	.fixed-nav i.icon-arrow{
		transition: 0.5s;
	}
	.fixed-nav i.remotesY{
		transform: rotateZ(180deg);
	}
	@media screen and (max-width: 768px) {
		.proScrollTop{
			left: 0px;
		}
		.proScrollTop.is-show{
			display: block;
		}
		.fixed-box{
			display: block!important;
			height: 65px;
		}
		.fixed-nav{
			padding: 20px 5px;
			font-size: 16px;
		}
		.nav-menu{
			min-height: 0px;
			height: auto;
			z-index: 9999;
		}
		.nav-menu-ul{
			position: fixed;
			width: 100%;
			left: 0px;
			top: 68px;
			transition: 1s;
			z-index: 9999;
			background-color: #fff;
			border-top: 1px solid #eee;
			border-bottom: 1px solid #eee;
		}
		.nav-menu .proScrollTop.showMenu{
			top: 66px;
			opacity: 1;
		}
		.nav-menu .showMenu{
			top: 230px;
			opacity: 1;
		}
		.navScrollTop{
			left: 0px;
			top: 0px;
		}
		.navShade{
			background-color: #000;
			opacity: 0.3;
		}
		.showmenus{
			display: none;
			opacity: 0;
		}
		.arrowdown{
			transition: 0.5s;
		}
		.arrowup{
			transform: rotate(180deg);
			transition: 0.5s;
		}
    div.product-list-image{
      height: auto;
      line-height: unset;
    }
	}
	.pro-model{
		margin: 10px 0px 5px;
	}
	.pro-content-row{
		position: relative;
	}
	.pro-content-row ul{
		/* padding: 0px 10px; */
	}
	.menu-href{
		background-color: #fff;
		padding: 0px 12px;
		/* position: fixed; */
		/* margin-left: 1000px; */
	}
	.menu-href.fixedtop{
		/* top: 120px; */
	}
	.menu-href h3{
		padding-bottom: 5px;
		border-bottom: 2px dashed #eee;
		font-size: 15px;
	}
	.menu-href ul{
		padding-bottom: 20px;
	}
	.menu-href li{
		padding: 10px 0px 5px;
		cursor: pointer;
		border-bottom: 1px solid #eee;
	}
	.menu-href li:hover{
		color: #f00;
	}
	.menu-href li i{
		color: #409EFF;
		margin-right: 10px;
		font-size: 16px;
	}
	.product-list-image{
		padding: 12px 10px;
    height: 240px;
    line-height: 240px;
    text-align: center;
    border-bottom: 1px solid #eee;
	}
	.buy_link{
		color:#1890ff;
    padding:5px 10px;
		background: #e6f7ff;
		border:1px solid #91d5ff;
    border-radius:2px;
	}
	.dtl-btn{
		color:#f5222d;
		padding:5px 10px;
		background: #fff1f0;
		border:1px solid #ffa39e;
		border-radius:2px;
	}
	.dtl-link .el-button{
		padding:0px;
	}
	.dtl-link .el-button--text{
		color:#f5222d;
	}
</style>




















// WEBPACK FOOTER //
// src/views/proNav.vue